// Browsing history for this page session only. Never persisted or sent to the
// server, and scoped to the viewer so an account change cannot reuse it.
const viewedBacks = new Map();
const MAX_ENTRIES = 500;

export function listingReviewViewer(auth) {
  return auth?.user?.sub || auth?.user?._id || auth?.user?.id || auth?.token || 'anonymous';
}

function identityOf(listing) {
  const raw = listing?._original?.listing || listing?._original || listing?.listing || listing;
  const ids = [...new Set([listing, raw].flatMap((value) => {
    if (!value || typeof value !== 'object') return [];
    return [value._id, value.id, value.normalizedId,
      value.source === 'internal' ? value.sourceId : null];
  }).filter(Boolean).map(String))];
  const revision = raw?.updatedAt || raw?.lastSyncedAt || listing?.updatedAt || '';
  return { ids, revision: String(revision) };
}

export function rememberListingBack(listing, viewer = 'anonymous') {
  const { ids, revision } = identityOf(listing);
  for (const id of ids) {
    const key = JSON.stringify([viewer, id]);
    viewedBacks.delete(key);
    viewedBacks.set(key, revision);
  }
  while (viewedBacks.size > MAX_ENTRIES) viewedBacks.delete(viewedBacks.keys().next().value);
}

export function hasViewedListingBack(listing, viewer = 'anonymous') {
  const { ids, revision } = identityOf(listing);
  return ids.some((id) => {
    const key = JSON.stringify([viewer, id]);
    if (!viewedBacks.has(key)) return false;
    const seenRevision = viewedBacks.get(key);
    return !revision || !seenRevision || revision === seenRevision;
  });
}

export function clearListingReviewHistory() {
  viewedBacks.clear();
}
